export const MAN_CHARGE_AND_GO = 'MAN Charge&Go';

export const TCS = 'TRATON Charging Solutions AB';

export const TERMS_AND_CONDITIONS_URL: string = 'https://rio.cloud/de/documents/man-charge-and-go/tos';

export const PRIVACY_POLICY_URL: string =
    'https://rio.cloud/{language}/documents/man-charge-and-go/privacy-policy-man-truck-bus-se';

export const TCS_PRIVACY_POLICY_URL: string =
    'https://rio.cloud/en/documents/man-charge-and-go/privacy-policy-traton-charging-solutions';

export const RIO_CUSTOMER_CENTER: string = 'https://marketplace.rio.cloud/customerCenter/company';

export const RIO_MARKETPLACE_URL: string = 'https://rio.cloud/{language}/marketplace/overview';

export const RIO_PRICE_LIST_URL: string = 'https://rio.cloud/{language}/documents/man-charge-and-go/pricelist';

export const RIO_MARKETPLACE_MCG_URL: string = 'https://rio.cloud/{language}/marketplace/produkt/man-charge-and-go';

export const DRIVER_APP_MANUAL_URL: string = 'https://www.man.eu/global/en/service/man-driver-app-103744.html';

export const CHARGING_CARDS_CHARACTER_LIMIT: number = 25;

export const MIN_CARDS_REQUEST_LIMIT: number = 1;

export const MAX_CARDS_REQUEST_LIMIT: number = 40;
